import {
  BsBank,
  BsCashCoin,
  BsFileEarmarkCheck,
  BsFolderCheck,
} from "react-icons/bs";
import { FaCcAmazonPay } from "react-icons/fa";
import {
  MdOutlineDashboardCustomize,
  MdOutlineStorefront,
} from "react-icons/md";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
export const reports = [
  {
    id: "1",
    name: "گردش اشخاص",
    path: "/dashboard/accounting/reports/personInfo",
    icon: <RiMoneyDollarCircleLine size={25} />,
    color: "#ff974a",
    type: "menu",
  },
  {
    id: "1",
    name: "گردش صندوق",
    path: "/dashboard/accounting/reports/cash-desk",
    icon: <BsCashCoin size={25} />,
    color: "#0062ff",
    type: "menu",
  },
  {
    id: "1",
    name: "گردش بانک ها",
    path: "/dashboard/accounting/reports/banks",
    icon: <BsBank size={25} />,
    color: "#13b374",
    type: "menu",
  },
  {
    id: "1",
    name: "گردش چک های دریافتی",
    path: "/dashboard/accounting/reports/checksReceived",
    icon: <BsFileEarmarkCheck size={25} />,
    color: "#e02f87",
    type: "menu",
  },
  {
    id: "1",
    name: "گردش چک های پرداختی",
    path: "/dashboard/accounting/reports/checksPaid",
    icon: <BsFolderCheck size={25} />,
    color: "#e02f87",
    type: "menu",
  },
  {
    id: "1",
    name: "گردش درآمدها",
    path: "/dashboard/accounting/reports/income",
    icon: <FaCcAmazonPay size={25} />,
    color: "#ff0000",
    type: "menu",
  },
  {
    id: "1",
    name: "گردش هزینه ها",
    path: "/dashboard/accounting/reports/costs",
    icon: <RiMoneyDollarCircleLine size={25} />,
    color: "#ff974a",
    type: "menu",
  },
];
